import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, ButtonGroup } from '@mui/material';
import LeadList from './LeadList';
import ManageLead from './ManageLead';
import LeadScheduleTab from './LeadScheduleTab';

const segmentButtonSx = (active) => ({
  textTransform: 'none',
  fontWeight: 600,
  backgroundColor: active ? '#00594f' : '#fff',
  color: active ? '#fff' : '#444',
  borderColor: '#00594f !important',
  '&:hover': { backgroundColor: active ? '#006666' : '#f1faf4' },
});

export default function LeadTab({ subView }) {
  const navigate = useNavigate();
  const segment = subView === 'lead-schedule' ? 'schedule' : 'list';
  const [view, setView] = useState('list');
  const [editingLeadId, setEditingLeadId] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleSegmentChange = (next) => {
    setView('list');
    setEditingLeadId(null);
    if (next === 'schedule') {
      navigate('/business-dashboard/opportunity/lead-schedule?page=1');
    } else {
      navigate('/business-dashboard/opportunity/lead?page=1');
    }
  };

  const handleCreate = () => {
    setEditingLeadId(null);
    setView('form');
  };

  const handleEdit = (leadId) => {
    setEditingLeadId(leadId);
    setView('form');
  };

  const handleBack = () => {
    setView('list');
    setEditingLeadId(null);
  };

  const handleSaved = () => {
    setView('list');
    setEditingLeadId(null);
    setRefreshKey(k => k + 1);
  };

  return (
    <Box sx={{ pt: 2 }}>
      <ButtonGroup sx={{ mb: 2 }}>
        <Button sx={segmentButtonSx(segment === 'list')} onClick={() => handleSegmentChange('list')}>
          Lead list
        </Button>
        <Button sx={segmentButtonSx(segment === 'schedule')} onClick={() => handleSegmentChange('schedule')}>
          BD schedule — new lead
        </Button>
      </ButtonGroup>

      {segment === 'list' && (
        view === 'form' ? (
          <ManageLead leadId={editingLeadId} onBack={handleBack} onSaved={handleSaved} />
        ) : (
          <LeadList onCreate={handleCreate} onEdit={handleEdit} refreshKey={refreshKey} />
        )
      )}

      {segment === 'schedule' && (
        <LeadScheduleTab refreshKey={refreshKey} />
      )}
    </Box>
  );
}
